import React, { FC, useCallback } from 'react';
import { useIntl } from 'react-intl';
import Loading from '../../Loading';
import AdvancedFilter from '../AdvancedFilter';
import { Filterable, TGroup } from '../types';
import { useAdvancedDatasetOrCurrentPeopleFilter } from './context';

type Props = {
  value: TGroup | undefined;
  onChange?: (value: TGroup | undefined) => void;
  onValidChange?: (message: string | null) => void;
  suggestions: Filterable[];
  disabled?: boolean;
  required?: boolean;
  searchBarPlaceholder?: string;
};

const AdvancedDatasetOrCurrentPeopleFilter: FC<Props> = ({
  disabled = false,
  required = false,
  value,
  onChange,
  onValidChange,
  searchBarPlaceholder,
}) => {
  const { suggestions, selectedSuggestionConverter } =
    useAdvancedDatasetOrCurrentPeopleFilter();
  const { formatMessage } = useIntl();

  const handleOnChange = useCallback(
    (filters) => {
      onChange?.(filters);
    },
    [onChange]
  );

  if (!suggestions) {
    return (
      <Loading
        message={formatMessage({
          id: 'app.views.widgets.inputs.people_include_exclude_filter.message.loading_filters',
          defaultMessage: 'Loading filters...',
        })}
      />
    );
  }

  return (
    <AdvancedFilter
      disabled={disabled}
      required={required}
      suggestions={suggestions}
      suggestionForConditionConverter={selectedSuggestionConverter}
      value={value}
      onChange={handleOnChange}
      onValidChange={onValidChange}
      searchBarPlaceholder={searchBarPlaceholder}
    />
  );
};

export default React.memo(AdvancedDatasetOrCurrentPeopleFilter);
